import { Injectable } from '@angular/core';
import { HttpService } from "./http.service";
import { CreateResult } from "../models/create-result";
import { CustomTagsParticipantLinkViewModel } from "../models/custom-tags-participant-link";
import { CustomTagViewModel } from '../models/custom-tag';
import { debug } from 'util';
import { CustomTagsTerminalViewModel } from '../models/custom-tag-terminal-view-model';
import { TerminalParamViewModel } from '../models/terminal-param-view-model';
import { TerminalGroupsViewModel } from '../models/terminal-groups';
import { TerminalGroupsByParticipantLinkViewModel } from '../models/terminal-groups-participant-link';
import { TerminalGroupViewModel } from '../models/terminal-group-view-model';
import { TaParamsFilesViewModel } from '../models/ta-params-files-view-model';
import { VasServiceTypeViewModel } from '../models/vas-service-type';
import { VasProviderViewModel } from '../models/vas-provider';
import { VasConfigurationViewModel } from '../models/vas-configuration-view-model';

@Injectable({
  providedIn: 'root'
})
export class VASService {


  constructor(private _httpService: HttpService) {
  }

  public async GetServicesTypes(): Promise<VasServiceTypeViewModel[]> {
    const httpResult = await this._httpService.apiGet<VasServiceTypeViewModel[]>(`VAS/GetServiceTypes`);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetProviders(): Promise<VasProviderViewModel[]> {
    const httpResult = await this._httpService.apiGet<VasProviderViewModel[]>(`VAS/GetProviders`);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async Update(vas: VasConfigurationViewModel): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPost<CreateResult>(`VAS/UpdateVasConfig`, vas);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async GetCommissionConfig(participantId: number): Promise<VasConfigurationViewModel> {
    const httpResult = await this._httpService.apiGet<VasConfigurationViewModel>(`VAS/GetCommissionConfig/${participantId}`);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return;
  }


}
